import {COMMON} from '@/common/Constant'
import miniToastr from 'mini-toastr'
import * as _ from 'lodash'

import Toastr from 'toastr2'
import 'toastr2/dist/toastr.min.css'
const toastr = new Toastr()

import numbro from 'numbro'

export function SHOW_TOAST(type, message, timeout = COMMON.toastFadeTime, title = COMMON.toastTitleDefault) {
  miniToastr[type](message, title, timeout)
}

export function SHOW_TOAST_2(type, message, config, title = COMMON.toastTitleDefault) {
  const options = {
    tapToDismiss: true,
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: 'toast-top-right',
    preventDuplicates: false,
    onclick: null,
    showDuration: COMMON.toastShowDuration,
    hideDuration: COMMON.toastHideDuration,
    timeOut: COMMON.toastFadeTime,
    extendedTimeOut: COMMON.toastFadeTimeHover,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut'
  }
  _.merge(options, config)
  toastr[type](message, title, options)
}

export function convertInputFileToBase64(_file) {
  if (_file) {
    const reader = new FileReader()
    return new Promise(resolve => {
      reader.onload = ev => {
        resolve(ev.target.result)
      }
      reader.readAsDataURL(_file)
    })
  } else {
    return null
  }
}

export const numberFormat = (
  value,
  pattern = {
    thousandSeparated: true
  }
) => {
  if (
    value != null &&
    String(value).length > 0 &&
    /^-?(\d*|\d{0,2}[,\d{3}]*)(\.\d*)?$/.test(value)
  ) {
    const num = numbro(String(value).replace(/,/g, ''))
    if (num && num._value != null) {
      return num.format(pattern)
    }
  }

  return ''
}
